
export const negativeNumberStringValidation = (data: any) => {
    if (data == null) {
        return false
    }
    if (data.length) {
        return /^[0-9]+$/.test(data)
    }
}

export const emailValidation = (data: any) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data)
}

export const negativeNumberValidation = (data: any) => {
    return /(?<!\d)-\d+\.?\d*/.test(data)
}

export const validatePhone = (phone) => {

    var regx = /^[6-9]\d{9}$/;
    // console.log(regx.test(phone));
    // console.log(phone);
    
    if (regx.test(phone))
        return true
    else
        return false
}

export const validationChecking = (objects, whatsappSetting) => {
    let checking = false
    if (whatsappSetting.appName!=="") {
      checking = Object.keys(objects).every((item) => {
        if (objects[item] && objects[item] !== '') {
          
          if (item == 'sourceMobileNumber' ) {
            let number = objects[item].toString()
            return validatePhone(number)
          }
          if (item == 'apiKey' || item == 'appName' || item == 'templateId' || item == 'areaOfInterest') {
            return /^[a-zA-Z\s]+$/.test(objects[item])
          }
          else {
            return true
          }
        }
        else {
          return true
        }
      })
    }
    return checking
  }

